export const SET_YEARLIST = "setYearList";
export const SET_ELECTIONLIST = "setElectionList";
export const SET_CANDIDATELIST = "setCandidateList";
export const SET_CONTESTLIST = "setContestList";
export const SET_ERROR = "setError";
export const SET_CONTEST = "setContest";
export const SET_CANDIDATESTATEMENT = "setCandidateStatement";
export const SET_CANDIDATESTATEMENTINFO = "setCandidateStatementInfo";
export const CLEAR_YEARLIST = "clearYearList";
export const CLEAR_ELECTIONLIST = "clearElectionList";
export const CLEAR_CONTESTLIST = "clearContestList";
export const CLEAR_CONTEST = "clearContestContest";
export const SET_ELECTION = "setElection";
export const SET_YEAR = "setYear";
export const SET_CONTEST_BY_CANDIDATE = "setContestByCandidate";
export const SET_LANGUAGE_CODE = "setLanguage";
export const SET_SEARCH_INPUT = "setSearchInput";